import { render, staticRenderFns } from "./Mini_Suggest.vue?vue&type=template&id=5b12b130&scoped=true&"
import script from "./Mini_Suggest.vue?vue&type=script&lang=js&"
export * from "./Mini_Suggest.vue?vue&type=script&lang=js&"
import style0 from "./Mini_Suggest.vue?vue&type=style&index=0&id=5b12b130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b12b130",
  null
  
)

export default component.exports